import { haveValue } from "../../helper/common";
import useTranslator from "../../hooks/useTranslator";
import ProfileRow from "./ProfileRow";

const ProfileTable = ({
  profile,
  properties,
  loadData,
  user,
  openAssignLLModal,
  checkSalary,
  rentPercentage,
  rentDoc,
}) => {
  const { _t } = useTranslator();

  return (
    <>
      <div className="upcoming-box ">
        <table className="upcoming-table landlord-table bigtable_set">
          <thead>
            <tr className="first-row">
              <th> {_t("tenant")} </th>
              <th> {_t("score", "Field in profile table")} </th>
              <th> {_t("effortRate", "Field in profile table")} </th>
              <th> {_t("linkedProperties", "Field in profile table")} </th>
              {user?.isParentLL && (
                <th>
                  {" "}
                  {_t(
                    "assignAgent/Landlord",
                    "Field located in the agency-side profile table"
                  )}{" "}
                </th>
              )}
              <th> {_t("profileCompletion", "Field in profile table")} </th>
              <th> {_t("added", "Field in profile table")} </th>
              <th> </th>
            </tr>
          </thead>

          <tbody>
            {haveValue(profile)
              ? profile.map((data) => (
                  <ProfileRow
                    profile={data}
                    properties={properties}
                    loadData={loadData}
                    openAssignLLModal={openAssignLLModal}
                    checkSalary={checkSalary}
                    rentPercentage={rentPercentage}
                    rentDoc={rentDoc}
                  />
                ))
              : _t("noDetailsFound")}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ProfileTable;
